import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as AuthActions from '@authed/auth.actions'
import { useAppSelector } from '@redux/hooks'
import { LoadingPage } from '../global/loading'

interface BootstrapGuardProps {
  children: React.ReactNode
}

export function BootstrapGuard({ children }: BootstrapGuardProps) {
  const dispatch = useDispatch()
  const isBootstrapped = !!useAppSelector(state => state.Auth.user)
  const isBootstrapping = !!useAppSelector(state => state.Auth.bootstrapping)

  /*
   * If we aren't bootstrapped and aren't currently in the process,
   * then we want to make sure that we've tried. This ensures that
   * we have at least tried to load the bootstrap information once.
   */
  useEffect(() => {
    const shouldBootstrap = !isBootstrapped && !isBootstrapping

    if (shouldBootstrap) {
      dispatch(AuthActions.getUser(localStorage.getItem('session_toe') ?? ''))
    }
  }, [isBootstrapped, isBootstrapping])

  /*
   * If we're in the process of loading the bootstrap information, we want
   * to show a loading screen until we've completed, whether that means
   * loaded or failed.
   */
  if (isBootstrapping) {
    return <LoadingPage />
  }

  // otherwise, return the children of the guard
  return <>{children}</>
}
